import {Directive, ElementRef, Inject, Input, OnInit} from '@angular/core';
import {BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME} from "../constants/commons";

@Directive({
  standalone: false,
  selector: '[appBringozIdGenerator]'
})
export class BringozIdGeneratorDirective implements OnInit {
  @Input('appBringozIdGenerator') bringozIdGenerator: string;

  constructor(@Inject(ElementRef) private elementRef: ElementRef) {
  }

  ngOnInit(): void {
    this.elementRef.nativeElement.setAttribute(BRINGOZ_ID_GENERATOR_ATTRIBUTE_NAME, this.bringozIdGenerator);
  }
}
